import type { RfiDetailsPageType } from 'app/modules/rfi/models';
import type { RfiRequestsPayload } from 'app/modules/rfi/queries/useListRfiRequestsByOrg';

const BASE = ['rfi'] as const;

export const RFI_QUERY_KEYS = {
  listTemplates: () => [...BASE, 'templates'] as const,
  getBranding: (orgId: number) => [...BASE, 'branding', orgId] as const,
  listRequests: (
    detailsPageType: RfiDetailsPageType,
    id: string,
    cachedHashedId?: string,
  ) =>
    cachedHashedId
      ? ([...BASE, 'requests', detailsPageType, id, cachedHashedId] as const)
      : ([...BASE, 'requests', detailsPageType, id] as const),
  listRequestsByOrg: (payload: RfiRequestsPayload) =>
    [...BASE, 'requestsByOrg', payload] as const,
  getResponsesByToken: (token: string) =>
    [...BASE, 'responses', token] as const,
};
